import { LOCALE_LANGUAGE_TAGS } from '@/constants/locale';

export const getLanguageTag = (locale) => LOCALE_LANGUAGE_TAGS[locale] ?? locale;
